import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import IconButton from '@material-ui/core/IconButton';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Tooltip } from '@material-ui/core';
import './CopyToClipboardButton.scss';

export default function CopyToClipboardButton (props) {
    const [value,set_value] = useState(props.text);
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        set_value(props.text);
    },[props.text])
    const onCopy = () => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000);
    };

    const codeStyle = {
      background: '#f8f8f8',
      padding: '5px',
      borderRadius: '5px',
      fontFamily: 'Monospace',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: 'max-content'
    };

    return (
      <div>
        <div style={codeStyle}>
          <code>{value}</code> 
          <CopyToClipboard text={value} onCopy={onCopy}>  
            {!isCopied ?(
              <Tooltip title="Copy to clipboard">
              <AssignmentIcon color="primary" className='AssignmentIcon'/>
            </Tooltip>
            ):(
              <Tooltip title="Copied!">
            <AssignmentTurnedInIcon className='AssignmentIcon'/>
          </Tooltip>
      )}
          </CopyToClipboard>
        </div>
      </div>
    );
};